import axios, { AxiosRequestConfig } from "axios";
import { store } from "../Pages/ReduxStore/store";
import { toast } from "react-toastify";
import { filterNoneOptions } from "../Component/filters";
import { cacheRead, getCachedRead, queueMutation } from "../offline/offlineQueue";

export const baseURL = window.env?.BASE_URL;
console.log(baseURL, window.env);
//export const baseURL = "https://localhost:7182/api";

// export const siteInfo={
//   siteId:"2b143042-85e1-4edb-be93-ddfc87905275",
//   name:"Shah Alam"
// }

export const siteInfo = {
  siteId: "e1bbe690-1ac0-41e4-9105-5e4449214082",
  name: "Combined Cycle Site",
};

export const axiosPrivate = axios.create({
  baseURL: baseURL,
});

// --- Offline support (opt-in per call via config.offlineCache / config.offlineQueue) ---
// Short-circuits at the request stage when offline, so calling code's .then()
// still runs (with cached data or an optimistic result) exactly like a normal
// successful response. Registered first so it runs before the other response
// interceptors below, which only ever see genuine (non-offline) errors.
axiosPrivate.interceptors.request.use(async (config) => {
  if (navigator.onLine) {
    return config;
  }
  if (config.method === "get" && config.offlineCache) {
    const cached = await getCachedRead(config.url);
    return Promise.reject({ __offlineCached: true, cached, config });
  }
  if ((config.method === "post" || config.method === "put") && config.offlineQueue) {
    const { entityType, optimisticResult, displayRow } = config.offlineQueue;
    const tempId = await queueMutation({
      entityType,
      method: config.method,
      url: config.url,
      payload: config.data,
      displayRow,
    });
    return Promise.reject({ __offlineQueued: true, optimisticResult, tempId, config });
  }
  return config;
});

axiosPrivate.interceptors.response.use(
  (response) => {
    if (response.config.method === "get" && response.config.offlineCache) {
      cacheRead(response.config.url, response.config.offlineCache.entityType, response.data);
    }
    return response;
  },
  (error) => {
    if (error && error.__offlineCached) {
      if (error.cached) {
        return Promise.resolve({
          data: error.cached.data,
          status: 200,
          headers: {},
          config: error.config,
          __offlineCached: true,
          __cachedAt: error.cached.timestamp,
        });
      }
      return Promise.reject(error);
    }
    if (error && error.__offlineQueued) {
      return Promise.resolve({
        data: error.optimisticResult,
        status: 200,
        headers: {},
        config: { ...error.config, skipSuccessToast: true },
        __offlineQueued: true,
        __tempId: error.tempId,
      });
    }
    return Promise.reject(error);
  },
);

const excludedEndpoints = [
  "/kpireport/getmtbfreport",
  "/kpireport/getmttrreport",
  "/kpireport/getcomplaiancechart",
  "/kpireport/getcompliancereportbystatus",
  "/kpireport/getservicerequestreport",
  "/kpireport/getworkordercostreport",
  "/kpireport/failurereportforfailures",
  "/kpireport/failurereportforproblem",
  "/kpireport/failurereportforcauses",
  "/kpireport/failurereportforremedy",
  "/kpireport/getkpichartlocation",
  "/workorder/searchcloseworkorder",
  "/kpireport/getcompliancereportbystatuswolist",
  "/kpireport/getcostreportforwolist",
  "/kpireport/getKPIReportComplaianceWOList",
  "/kpireport/getservicerequestreportlist",
  "/kpireport/getmtbfreportwoList",
  "/kpireport/getmttrreportwoList",
  "/kpireport/failurereportforfailuresWOList",
  "/kpireport/failurereportforproblemWOList",
  "/kpireport/failurereportforcausesWOList",
  "/kpireport/failurereportforremedyWOList",
  "/workorder/getiotdata",
  "/workorder/getlogs",
  "/workorder/create",
  "/inventory/search",
  "/workorder/search",
  "/workordertasklabour/getLabourScheduleList",
  "/servicerequest/create",
  "/servicerequest/update",
  "/servicerequest/converttoworkorder",
];

axiosPrivate.interceptors.response.use(
  (response) => {
    const method = response.config.method;
    const url = response.config.url;

    if (url && url.toLowerCase().includes("/selectlist/")) {
      if (Array.isArray(response.data)) {
        response.data = filterNoneOptions(response.data);
      } else if (response.data && Array.isArray(response.data.result)) {
        response.data.result = filterNoneOptions(response.data.result);
      }
    }

    // Check if API is in the excluded list
    // const isExcluded = excludedEndpoints.some((endpoint) => url.includes(endpoint));

    // if (!isExcluded) {
    //   if (method === "post" && url === "users/signin") {
    //     toast.success("Successfully logged in!");
    //   } else if (method === "post") {
    //     toast.success("Successfully created!");
    //   } else if (method === "put") {
    //     toast.success("Successfully updated!");
    //   } else if (method === "delete") {
    //     toast.success("Successfully deleted!");
    //   }
    // }

    if (
      !response.config.skipSuccessToast &&
      response.data.message !== "" &&
      response.data.message !== undefined &&
      response.data.message !== null
    ) {
      toast.success(response.data.message);
    }

    return response;
  },
  // (error) => {
  //   const url = error.config?.url || "";
  //   const isExcluded = excludedEndpoints.some((endpoint) => url.includes(endpoint));

  //   if (!isExcluded) {
  //     // Display error message in toast
  //     const errorMessage = error.response.data.FailureMessage;
  //     toast.error(errorMessage);
  //   }

  //   return Promise.reject(error);
  // }
);

axiosPrivate.interceptors.request.use((config) => {
  const storeData = store.getState();
  const tokenData = storeData.auth.loginInfo.accessToken;
  if (tokenData !== undefined) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = tokenData;
  }
  return config;
});

// axiosPrivate.interceptors.response.use(async function(config){

//   return config;
// },(error) => {
//   // console.log(error.response, "errrr");
//   return new Promise( (resolve) => {

//     const originalRequest = error.config;
//     // console.log("checkkk");
//     const refreshToken = store.getState().auth.loginInfo.refreshToken;

//     if (error.response && error.response.data.StatusCode === 401 && refreshToken) {
//       // console.log("res");
//       originalRequest._retry = true;

//       // body: formBody
//       console.log(refreshToken)
//       const response =  axios
//         .post(`${baseURL}/users/refreshtoken?refreshtoken=${refreshToken}`)
//         .then((res) => {
//           console.log(res, "ccccc");
//           return res;
//         })
//         .then((res) => {
//           // console.log(res)
//           store.dispatch({type:"updateAccessToken",payload:res.data.result});
//           originalRequest.headers.authorization = res.data.result.accessToken;
//           return axios(originalRequest);
//         })
//         .catch((e) => {
//           if(e.response.data.StatusCode === 401){
//             store.dispatch({type:"logout",payload:{}});
//             console.log(e)
//             toast.warning("Session Expired")
//             // window.location.href = '/'
//             //  throw e

//           }
//           return Promise.reject(e);
//         });
//       resolve(response);
//     }
//     // else{
//     //   throw error;
//     // }

//     if (error.response) {
//       throw error.response.data;
//     }

//     return Promise.reject(error);
//   });
// })

let isRefreshing = false;
let refreshQueue = [];
let unauthorizedUrls = [];
axiosPrivate.interceptors.response.use(
  (response) => {
    console.log(response.data);
    if (response.data.statusCode === 204) {
      return {
        ...response,
        data: {
          ...response.data,
          result: [],
        },
      };
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    const storeData = store.getState();
    const refreshToken = storeData.auth.loginInfo.refreshToken;

    if (error.response && error.response.status === 401) {
      // Store the 401 URL in the array
      if (originalRequest?.url) {
        unauthorizedUrls.push(originalRequest.url);
      }

      // Optionally log all 401 URLs for debugging
      console.log("all401url:", unauthorizedUrls);
    }

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry &&
      refreshToken
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          refreshQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return axiosPrivate(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        axios.interceptors.request.use((request) => {
          console.log("Request Headers:", request.headers);
          return request;
        });

        const res = await axios.post(
          `${baseURL}/users/refreshtoken?refreshtoken=${refreshToken}`,
        );

        console.log("Response Data:", res.data);
        // toast.success(res.data.message)

        const newAccessToken = res.data.result.accessToken;

        // Update the store with new tokens
        store.dispatch({
          type: "updateAccessToken",
          payload: res.data.result,
        });
        console.log("token", res.data.result.accessToken);
        console.log(
          "Updated Token:",
          store.getState().auth.loginInfo.accessToken,
        );

        // Update the default headers and retry the original request
        axiosPrivate.defaults.headers.common["Authorization"] =
          `Bearer ${newAccessToken}`;
        refreshQueue.forEach((prom) => prom.resolve(newAccessToken));
        refreshQueue = [];
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return axiosPrivate(originalRequest);
      } catch (err) {
        // Handle refresh token expiration or errors
        if (
          err.response.data.StatusCode === 401 ||
          err.response.status === 400
        ) {
          store.dispatch({ type: "logout", payload: {} }); // Use the action creator
          toast.warning("Session Expired");
        }

        refreshQueue.forEach((prom) => prom.reject(err));
        refreshQueue = [];
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    if (error.response) {
      console.log(error.response);
      if (
        error.response.data.statusCode !== 204 &&
        error.response.data.StatusCode !== 401
      ) {
        console.log("Checktest");
        toast.error(
          error.response.data.failureMessage ||
            error.response.data.FailureMessage,
        );
      }
      return Promise.reject(error);
    }

    return Promise.reject(error);
  },
);
